import type { LeadCategory } from '@schwarz/contract';
import { leadCategoryLabels } from '@schwarz/contract';

import styles from './CategoryChip.module.css';

/**
 * The lead category, as a chip (S08).
 *
 * `UNKNOWN` gets its own muted treatment rather than borrowing another
 * category's colour. It means the analyzer could not decide, and dressing
 * indecision as a finding — in the green of a hot lead or the red of a refusal —
 * would be the most misleading thing on the page.
 */
export function CategoryChip({ category }: { category: LeadCategory }): JSX.Element {
  return (
    <span className={`${styles.chip} ${styles[category]}`}>{leadCategoryLabels[category]}</span>
  );
}
